import { render } from "./UploadDoc.vue?vue&type=template&id=6c84826e&scoped=true&ts=true"
import script from "./UploadDoc.vue?vue&type=script&lang=ts"
export * from "./UploadDoc.vue?vue&type=script&lang=ts"

import "./UploadDoc.vue?vue&type=style&index=0&id=6c84826e&scoped=true&lang=css"
import "./UploadDoc.vue?vue&type=style&index=1&id=6c84826e&scoped=true&lang=scss"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c84826e"]])

export default __exports__